import { LabeledValue_Root } from './LabeledValue.style';

export var LabeledValue = LabeledValue_Root;
//# sourceMappingURL=LabeledValue.js.map